// Chat baru for a Non-Penyedia ("/", screens/Chat.tsx): four starting points
// under the composer and the saved questions. Two ask Pluto at once
// (Perencanaan Pengadaan, Panduan penyusunan HPS); two open a menu (Alur PBJ,
// the template library) and show only while their role feature is on.
// A Penyedia gets its own four (PENYEDIA_HOME_PROMPTS, from Simulasi Pluto
// v4 supplierHome): Project Penyedia, Temukan Paket on it, the requirement
// matrix, and Generator Dokumen.
import type { Feature } from "../api";
import { useFeatures } from "../shell/features";
import { Glyph, type GlyphName } from "../ui/icons";

interface PromptCard {
  id: string;
  icon: GlyphName;
  title: string;
  hint: string;
  /** Asked as the user's message. */
  ask?: string;
  /** Opened instead, when the feature is on. */
  href?: string;
  feature?: Feature;
}

export const HOME_PROMPTS: PromptCard[] = [
  {
    id: "perencanaan",
    icon: "taskSquare",
    title: "Perencanaan Pengadaan",
    hint: "Langkah, RUP, dan dokumen pendukung",
    ask: "Apa langkah dan dokumen wajib pada tahap Perencanaan Pengadaan?",
  },
  {
    id: "hps",
    icon: "calculator",
    title: "Panduan penyusunan HPS",
    hint: "Sumber harga, perhitungan, dan verifikasinya",
    ask: "Bagaimana tahapan menyusun HPS dan sumber harga yang dapat dipakai?",
  },
  { id: "alur", icon: "layers", title: "Jelajahi Alur PBJ", hint: "17 alur untuk metode pemilihan dan Swakelola", href: "/alur-pbj", feature: "pbj_flow" },
  { id: "template", icon: "docAdd", title: "Buat dokumen pengadaan", hint: "Template dokumen tiap tahap PBJ", href: "/template", feature: "templates" },
];

export const PENYEDIA_HOME_PROMPTS: PromptCard[] = [
  { id: "project", icon: "folder", title: "Buka Project Penyedia", hint: "Empat tahap kerja utama", href: "/project-penyedia", feature: "projects" },
  { id: "pantau", icon: "searchNormal", title: "Cari dan catat paket", hint: "Sumber resmi SiRUP dan SPSE", href: "/project-penyedia", feature: "pantau_paket" },
  {
    id: "persyaratan",
    icon: "taskSquare",
    title: "Analisis persyaratan",
    hint: "Susun matriks kepatuhan penawaran",
    ask: "Bagaimana menyusun matriks kepatuhan persyaratan administrasi, kualifikasi, teknis, dan harga dari dokumen pemilihan?",
  },
  { id: "template", icon: "docAdd", title: "Dokumen penawaran", hint: "Administrasi, teknis, kualifikasi, harga", href: "/template", feature: "templates" },
];

export function HomePrompts({ onAsk, disabled = false, penyedia = false }: { onAsk: (text: string) => void; disabled?: boolean; penyedia?: boolean }) {
  const features = useFeatures();
  const cards = (penyedia ? PENYEDIA_HOME_PROMPTS : HOME_PROMPTS).filter((c) => !c.feature || features.has(c.feature));
  const body = (c: PromptCard) => (
    <>
      <Glyph name={c.icon} size={20} />
      <span className="pbj-prompt-text">
        <span className="pbj-prompt-title">{c.title}</span>
        <span className="pbj-prompt-hint">{c.hint}</span>
      </span>
    </>
  );
  return (
    <ul className="pbj-prompts" aria-label="Mulai dari sini">
      {cards.map((c) => (
        <li key={c.id}>
          {c.href ? (
            <a className="pbj-prompt" href={c.href}>
              {body(c)}
            </a>
          ) : (
            <button type="button" className="pbj-prompt" disabled={disabled} onClick={() => onAsk(c.ask!)}>
              {body(c)}
            </button>
          )}
        </li>
      ))}
    </ul>
  );
}
